const initState = {
  isDeleting: false,
  error: null,
}

export default initState
